<script>
  import { checkbox } from 'vue-strap';
  import tipoPassagemServico from '~modulos/tipo-passagem/servico';
  import projetoServico from '~modulos/projeto/servico';

  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true,
      },
      tipos: {
        type: Object,
        required: true,
      },
      motivos: {
        type: Object,
        required: true,
      },
      apenasIda: {
        type: Boolean,
        required: false, 
        default: false,
      },
      rubricas: {
        type: Array,
        required: true,
      },
      rubricaSubrubrica: {
        type: Object,
        required: true,
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        tiposPassagem: [],
        subrubricas: [],
      }
    },
    computed: {
      motivoContador() {
        let quantidadeCaracteres = this.motivos.passagem ?
          this.motivos.passagem.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      listaTiposPassagem() {
        return tipoPassagemServico
          .lista()
          .then(tiposPassagem => {
            this.tiposPassagem = tiposPassagem;
          });
      },
      listaDeSubrubricas(idProjeto = null, idRubrica = null) {
        idProjeto = this.solicitacao.idProjeto || idProjeto;
        idRubrica = this.rubricaSubrubrica.idRubrica || idRubrica;

        this.rubricaSubrubrica.idSubrubrica = '';
        this.subrubricas = [];

        if (!idRubrica) return;

        return projetoServico
          .subrubricas(idProjeto, idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      limparSubrubricas() {
        this.subrubricas = [];
      }
    },
    mounted() {
      this.listaTiposPassagem();
    },
    watch: {
      'rubricaSubrubrica.idRubrica': 'limparSubrubricas'
    }
  }
</script>

<template>
  <div>

    <div class="row" v-if="!edicao">
      <div class="col-xs-12">
        <div class="form-group chackboxes">
          <checkbox v-model="tipos.passagem"
                    :true-value="true"
                    type="success">
            Passagens
          </checkbox>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-5" v-if="!edicao"></div>

    <h3 class="m-t-none m-b">Bagagem</h3>
    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group chackboxes">
          <checkbox v-model="solicitacao.despacharBagagem"
                    :true-value="1"
                    :false-value="0"
                    :disabled="!tipos.passagem"
                    type="success">
            Despachar bagagem
          </checkbox>
        </div>
      </div>
    </div>

    <h3 class="m-t-none m-b" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb">Rubrica e Subrubrica</h3>
    <div class="hr-line-dashed margin-top-5" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb"></div>

    <div class="row" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb">
      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select class="form-control"
                  id="rubrica"
                  v-model="rubricaSubrubrica.idRubrica"
                  data-vv-name="rubrica"
                  data-vv-as="rubrica"
                  :disabled="!tipos.passagem"
                  v-validate="'required'"
                  @change="listaDeSubrubricas">
            <option value="">Selecione...</option>
            <option :value="rubrica.id"
                    v-for="rubrica in rubricas">
              {{ rubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select class="form-control"
                  id="subrubrica"
                  v-model="rubricaSubrubrica.idSubrubrica"
                  data-vv-name="subrubrica"
                  data-vv-as="subrubrica"
                  :disabled="!tipos.passagem"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="subrubrica.id"
                    v-for="subrubrica in subrubricas">
              {{ subrubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
    </div>

    <h3 class="m-t-none m-b">Ida</h3>
    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadePassagemIda')}">
          <label class="control-label" for="quantidade-passagem-ida">Quantidade</label>

          <input id="quantidade-passagem-ida"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.quantidadePassagemIda"
                 :disabled="!tipos.passagem"
                 data-vv-name="quantidadePassagemIda"
                 data-vv-as="quantidade"
                 v-validate="tipos.passagem ? 'required' : ''"
                 v-numero>

          <p class="text-danger" v-show="errors.has('quantidadePassagemIda')">{{ errors.first('quantidadePassagemIda') }}</p>
        </div>
      </div>

      <div class="col-xs-4">
        <div class="form-group required" :class="{'has-error': errors.has('valorPassagemIda')}">
          <label class="control-label" for="valor-unitario-passagem-ida">Valor estimado</label>

          <input id="valor-unitario-passagem-ida"
                 class="form-control text-right"
                 type="text"
                 v-model="solicitacao.valorPassagemIda"
                 :disabled="!tipos.passagem"
                 v-mascara="'moeda'"
                 data-vv-name="valorPassagemIda"
                 data-vv-as="valor estimado"
                 v-validate="tipos.passagem ? 'required' : ''">

          <p class="text-danger" v-show="errors.has('valorPassagemIda')">{{ errors.first('valorPassagemIda') }}</p>
        </div>
      </div>

      <div class="col-xs-4">
        <div class="form-group required" :class="{'has-error': errors.has('idTipoPassagemIda')}">
          <label class="control-label" for="tipo-passagem-ida">Tipo de passagem</label>

          <select id="tipo-passagem-ida"
                  class="form-control"
                  v-model="solicitacao.idTipoPassagemIda"
                  :disabled="!tipos.passagem"
                  data-vv-name="idTipoPassagemIda"
                  data-vv-as="tipo de passagem"
                  v-validate="tipos.passagem ? 'required' : ''">
            <option value="">Selecione...</option>
            <option :value="tipoPassagem.idTipoPassagem" v-for="tipoPassagem in tiposPassagem">{{ tipoPassagem.descricaoTipoPassagem }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('idTipoPassagemIda')">{{ errors.first('idTipoPassagemIda') }}</p>
        </div>
      </div>
    </div>

    <div v-show="!apenasIda">
      <h3 class="m-t-none m-b">Volta</h3>
      <div class="hr-line-dashed margin-top-5"></div>

      <div class="row">
        <div class="col-lg-4">
          <div class="form-group required" :class="{'has-error': errors.has('quantidadePassagemVolta')}">
            <label class="control-label" for="quantidade-passagem-volta">Quantidade</label>

            <input id="quantidade-passagem-volta"
                   class="form-control"
                   type="text"
                   v-model="solicitacao.quantidadePassagemVolta"
                   :disabled="!tipos.passagem"
                   data-vv-name="quantidadePassagemVolta"
                   data-vv-as="quantidade"
                   v-validate="tipos.passagem && !apenasIda ? 'required' : ''"
                   v-numero>

            <p class="text-danger" v-show="errors.has('quantidadePassagemVolta')">{{ errors.first('quantidadePassagemVolta') }}</p>
          </div>
        </div>

        <div class="col-xs-4">
          <div class="form-group required" :class="{'has-error': errors.has('valorPassagemVolta')}">
            <label class="control-label" for="valor-unitario-passagem-volta">Valor estimado</label>

            <input id="valor-unitario-passagem-volta"
                   class="form-control text-right"
                   type="text"
                   v-model="solicitacao.valorPassagemVolta"
                   :disabled="!tipos.passagem"
                   v-mascara="'moeda'"
                   data-vv-name="valorPassagemVolta"
                   data-vv-as="valor estimado"
                   v-validate="tipos.passagem && !apenasIda ? 'required' : ''">

            <p class="text-danger" v-show="errors.has('valorPassagemVolta')">{{ errors.first('valorPassagemVolta') }}</p>
          </div>
        </div>

        <div class="col-xs-4">
          <div class="form-group required" :class="{'has-error': errors.has('idTipoPassagemVolta')}">
            <label class="control-label" for="tipo-passagem-volta">Tipo de passagem</label>

            <select id="tipo-passagem-volta"
                    class="form-control"
                    v-model="solicitacao.idTipoPassagemVolta"
                    :disabled="!tipos.passagem"
                    data-vv-name="idTipoPassagemVolta"
                    data-vv-as="tipo de passagem"
                    v-validate="tipos.passagem && !apenasIda ? 'required' : ''">
              <option value="">Selecione...</option>
              <option :value="tipoPassagem.idTipoPassagem" v-for="tipoPassagem in tiposPassagem">{{ tipoPassagem.descricaoTipoPassagem }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('idTipoPassagemVolta')">{{ errors.first('idTipoPassagemVolta') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('motivoPassagem')}">
          <label class="control-label" for="motivo-passagem">Motivo ({{ motivoContador }})</label>

          <textarea class="form-control"
                    id="motivo-passagem"
                    v-model="motivos.passagem"
                    :disabled="!tipos.passagem"
                    maxlength="500"
                    data-vv-name="motivoPassagem"
                    data-vv-as="motivo"
                    v-validate="tipos.passagem ? 'required' : ''">
          </textarea>

          <p class="text-danger" v-show="errors.has('motivoPassagem')">{{ errors.first('motivoPassagem') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="indicacao-fornecedor">Indicação de companhia/empresa</label>

          <textarea class="form-control"
                    id="indicacao-fornecedor"
                    v-model="solicitacao.indicacaoFornecedor"
                    :disabled="!tipos.passagem">
          </textarea>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-estrangeiro/componentes/compartilhado/FormPassagens.vue